import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import StageTab from './StageTab';

const useStyles = makeStyles((theme: any) => ({
  tabsContainer: {
    position: 'relative',
    width: 'calc(100% + 1.5px)',
  },
}));

export default function StageTabs({
  line,
  stages,
  handleStageToShow,
  handleStageUpdate,
  editMode,
}) {
  const classes = useStyles();

  return (
    <div className={classes.tabsContainer}>
      {stages.map((stage, i) => {
        return (
          <StageTab
            key={stage.id}
            line={line}
            stage={stage}
            totalStages={stages.length}
            handleStageToShow={handleStageToShow}
            index={i}
            editMode={editMode}
            handleStageUpdate={handleStageUpdate}
          />
        );
      })}
    </div>
  );
}
